// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__vjC2n","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__8GE6Z"};